/**
 * This event is dispatched when the queue got a status update.
 * See also `fetchStatus`.
 */ export const STATUS_EVENT = "RealQueue/Status";
